/* eslint-disable no-console */
// React and related imports
import React, { useMemo, useState } from 'react';

// RTK Query Hooks
import { useFetchContentContextQuery } from '../../redux/api/contentContextApi';

// i18 hooks
import { useTranslation } from 'react-i18next';

// Custom Components
import { ContentContextTableBody } from './ContentContextTableBody';
import { Loading } from '../Shared/Loading/Loading';
import { TableCommon } from '../Table/Table';
import { CustomPagination } from '../Shared/CustomPagination/CustomPagination';

// Custom Hooks
import { usePagination } from '../../hooks/usePagination';

// Uttils
import { SortableKeys, sortItems } from '../../utils/sortItems';

export const ContentContextTable: React.FC = () => {
  const { t } = useTranslation();

  const { currentPage, setCurrentPage, size } = usePagination();

  const { data: response, isLoading } = useFetchContentContextQuery({
    page: currentPage,
    size,
  });

  const [sortBy, setSortBy] = useState<string>('');
  const [ascending, setAscending] = useState(true);

  const contentContexts = response?.data.data;

  const sortedItems = useMemo(() => {
    return sortItems(contentContexts ?? [], sortBy as SortableKeys, ascending);
  }, [contentContexts, sortBy, ascending]);

  const tableColumns = useMemo(
    () => [
      { id: 'title', label: t('contentContext.title'), sortable: true },
      { id: 'status', label: t('contentContext.status') },
      { id: 'prayerName', label: t('contentContext.prayerName') },
      { id: 'time', label: t('contentContext.time'), sortable: true },
      { id: 'prayerDelta', label: t('contentContext.prayerDelta') },
      { id: 'updatedAt', label: t('contentContext.updatedAt'), sortable: true },
      { id: 'edit', label: t('contentContext.edit') },
    ],
    [t]
  );

  const handleSort = (field: string) => {
    if (sortBy === field) {
      setAscending(!ascending);
    } else {
      setSortBy(field);
      setAscending(true);
    }
  };

  if (isLoading) return <Loading />;

  return (
    <>
      {contentContexts && (
        <TableCommon columns={tableColumns} onClick={handleSort}>
          <ContentContextTableBody t={t} tableData={sortedItems} />
        </TableCommon>
      )}
      <CustomPagination
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        totalPages={response?.data?.meta?.pageCount ?? 1}
      />
    </>
  );
};
